var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 11,
    fill: "#4671F6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3.5,
    width: 14,
    height: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5556 3H5.44444C4.09689 3 3 4.09689 3 5.44444V16.5556C3 17.9031 4.09689 19 5.44444 19H16.5556C17.9031 19 19 17.9031 19 16.5556V5.44444C19 4.09689 17.9031 3 16.5556 3ZM16.1382 8.58267L9.916 14.8049C9.78578 14.9351 9.61511 15 9.44444 15C9.27378 15 9.10311 14.9351 8.97289 14.8049L6.30622 12.1382C6.04578 11.8778 6.04578 11.456 6.30622 11.1956C6.56667 10.9351 6.98844 10.9351 7.24889 11.1956L9.444 13.3907L15.1947 7.64C15.4551 7.37956 15.8769 7.37956 16.1373 7.64C16.3978 7.90044 16.3982 8.32222 16.1382 8.58267Z",
    fill: "#4671F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/checkIcon.dccaaf5e443b32d3020dc28481b159bc.svg";
export { ForwardRef as ReactComponent };